const critereI18n = {
  "fr": {
    "hero": {
      "title": "Critères de rachat",
      "desc": "Vérifiez les critères avant l’envoi pour éviter les refus et accélérer le traitement de vos pièces."
    },
    "intro": {
      "badge": "À vérifier",
      "title": "Les pièces que nous pouvons valoriser",
      "p1Strong": "Les prix dépendent du modèle et du grade",
      "p1Rest": "chaque pièce est testée à sa réception avant l’établissement de l’offre.",
      "p2Strong": "Les pièces hors critères ne sont pas rachetées",
      "p2Rest": "un tri avant l’envoi fait gagner du temps à votre équipe comme à la nôtre.",
      "alert": "Quantité minimale : 15 pièces. Plus le lot est important, plus l’envoi est intéressant."
    },
    "examples": {
      "title": "Grades des écrans",
      "cracks": {
        "title": "Grade A",
        "bodyPrefix": "Écran avec",
        "bodyStrong": "vitre cassée",
        "bodySuffix": ", affichage et tactile fonctionnels."
      },
      "spots": {
        "title": "Grade B",
        "bodyPrefix": "Écran avec",
        "onlyWord": "tactile hors service",
        "middle": "et",
        "perfectDisplay": "affichage exploitable",
        "bodySuffix": "."
      },
      "touch": {
        "title": "Grade C",
        "bodyPrefix": "Écran présentant",
        "seriesStrong": "de petites ombres ou de légères marques",
        "bodySuffix": " sur l’affichage."
      }
    },
    "recap": {
      "title": "Autres critères importants",
      "i1": "Les écrans avec des pixels HS ne sont pas repris.",
      "i2": "Les cartes mères doivent impérativement être débloquées iCloud.",
      "i3": "Les caméras et connecteurs de charge sont repris même lorsqu’ils sont hors service.",
      "i4": "Pour les iPhone, nous reprenons les modèles à partir des iPhone X et XR.",
      "i5": "Pour Samsung, Google, Huawei et les autres marques, privilégiez les modèles de moins de 5 ans.",
      "i6": "Nous reprenons uniquement les écrans originaux. Les copies ne sont pas acceptées.",
      "ctaTarifs": "Voir les tarifs",
      "ctaEnvoi": "Comment emballer ?"
    },
    "dialog": {
      "title": "Critères de rachat",
      "screens": "Écrans",
      "gradeA": "vitre cassée, affichage et tactile fonctionnels.",
      "gradeB": "tactile hors service, affichage exploitable.",
      "gradeC": "petites ombres ou légères marques sur l’affichage.",
      "originals": "Écrans originaux uniquement : les copies ne sont pas reprises.",
      "motherboardsLabel": "Cartes mères",
      "motherboards": "elles doivent impérativement être débloquées iCloud.",
      "partsLabel": "Connecteurs de charge et caméras",
      "parts": "nous les reprenons également lorsqu’ils sont hors service.",
      "disclaimer": "Merci de vérifier ces critères avant l’envoi. Les pièces qui ne les respectent pas mobilisent inutilement du temps de traitement pour votre équipe comme pour la nôtre.",
      "back": "Je reviens à ma sélection",
      "close": "Fermer",
      "understand": "Je comprends"
    }
  },
  "en": {
    "hero": {
      "title": "Buyback criteria",
      "desc": "Check the criteria before shipping to avoid rejected parts and speed up processing."
    },
    "intro": {
      "badge": "Check first",
      "title": "Parts we can recover",
      "p1Strong": "Prices depend on the model and grade",
      "p1Rest": "each part is tested upon receipt before we issue an offer.",
      "p2Strong": "Parts outside the criteria are not purchased",
      "p2Rest": "sorting before shipment saves time for both your team and ours.",
      "alert": "Minimum quantity: 15 parts. The larger the batch, the more worthwhile the shipment."
    },
    "examples": {
      "title": "Screen grades",
      "cracks": {
        "title": "Grade A",
        "bodyPrefix": "Screen with",
        "bodyStrong": "broken glass",
        "bodySuffix": ", working display and touch."
      },
      "spots": {
        "title": "Grade B",
        "bodyPrefix": "Screen with",
        "onlyWord": "non-working touch",
        "middle": "and a",
        "perfectDisplay": "usable display",
        "bodySuffix": "."
      },
      "touch": {
        "title": "Grade C",
        "bodyPrefix": "Screen showing",
        "seriesStrong": "small shadows or light marks",
        "bodySuffix": " on the display."
      }
    },
    "recap": {
      "title": "Other important criteria",
      "i1": "Screens with dead pixels are not accepted.",
      "i2": "Motherboards must be completely free of any iCloud lock.",
      "i3": "Cameras and charging connectors are accepted even when faulty.",
      "i4": "For iPhones, we accept models from the iPhone X and XR onwards.",
      "i5": "For Samsung, Google, Huawei and other brands, prioritize models less than 5 years old.",
      "i6": "We only purchase original screens. Copies are not accepted.",
      "ctaTarifs": "View prices",
      "ctaEnvoi": "How to pack?"
    },
    "dialog": {
      "title": "Buyback criteria",
      "screens": "Screens",
      "gradeA": "broken glass, working display and touch.",
      "gradeB": "non-working touch, usable display.",
      "gradeC": "small shadows or light marks on the display.",
      "originals": "Original screens only: copies are not accepted.",
      "motherboardsLabel": "Motherboards",
      "motherboards": "they must be completely free of any iCloud lock.",
      "partsLabel": "Charging connectors and cameras",
      "parts": "we also accept them when they are faulty.",
      "disclaimer": "Please check these criteria before shipping. Parts that do not meet them create unnecessary processing time for both your team and ours.",
      "back": "Back to my selection",
      "close": "Close",
      "understand": "I understand"
    }
  },
  "pl": {
    "hero": {
      "title": "Kryteria odkupu",
      "desc": "Sprawdź kryteria przed wysyłką, aby uniknąć odrzuceń i przyspieszyć obsługę części."
    },
    "intro": {
      "badge": "Do sprawdzenia",
      "title": "Części, które możemy odkupić",
      "p1Strong": "Cena zależy od modelu i klasy",
      "p1Rest": "każda część jest testowana po otrzymaniu przed przedstawieniem oferty.",
      "p2Strong": "Części niespełniające kryteriów nie są odkupywane",
      "p2Rest": "wstępne sortowanie oszczędza czas obu stronom.",
      "alert": "Minimalna ilość: 15 części. Im większa partia, tym bardziej opłacalna wysyłka."
    },
    "examples": {
      "title": "Klasy ekranów",
      "cracks": {
        "title": "Klasa A",
        "bodyPrefix": "Ekran z",
        "bodyStrong": "pękniętą szybą",
        "bodySuffix": ", działającym wyświetlaczem i dotykiem."
      },
      "spots": {
        "title": "Klasa B",
        "bodyPrefix": "Ekran z",
        "onlyWord": "niedziałającym dotykiem",
        "middle": "oraz",
        "perfectDisplay": "użytecznym wyświetlaczem",
        "bodySuffix": "."
      },
      "touch": {
        "title": "Klasa C",
        "bodyPrefix": "Ekran z",
        "seriesStrong": "małymi cieniami lub lekkimi śladami",
        "bodySuffix": " na wyświetlaczu."
      }
    },
    "recap": {
      "title": "Pozostałe ważne kryteria",
      "i1": "Ekrany z uszkodzonymi pikselami nie są przyjmowane.",
      "i2": "Płyty główne muszą być całkowicie odblokowane z iCloud.",
      "i3": "Aparaty i złącza ładowania przyjmujemy również wtedy, gdy są uszkodzone.",
      "i4": "W przypadku iPhone’ów przyjmujemy modele od iPhone X i XR.",
      "i5": "W przypadku Samsung, Google, Huawei i innych marek wybieraj modele nie starsze niż 5 lat.",
      "i6": "Odkupujemy wyłącznie oryginalne ekrany. Kopie nie są przyjmowane.",
      "ctaTarifs": "Zobacz ceny",
      "ctaEnvoi": "Jak zapakować?"
    },
    "dialog": {
      "title": "Kryteria odkupu",
      "screens": "Ekrany",
      "gradeA": "pęknięta szyba, działający wyświetlacz i dotyk.",
      "gradeB": "niedziałający dotyk, użyteczny wyświetlacz.",
      "gradeC": "małe cienie lub lekkie ślady na wyświetlaczu.",
      "originals": "Tylko oryginalne ekrany: kopie nie są przyjmowane.",
      "motherboardsLabel": "Płyty główne",
      "motherboards": "muszą być całkowicie odblokowane z iCloud.",
      "partsLabel": "Złącza ładowania i aparaty",
      "parts": "przyjmujemy je również wtedy, gdy są uszkodzone.",
      "disclaimer": "Sprawdź te kryteria przed wysyłką. Części, które ich nie spełniają, niepotrzebnie wydłużają obsługę po obu stronach.",
      "back": "Wróć do wyboru",
      "close": "Zamknij",
      "understand": "Rozumiem"
    }
  },
  "es": {
    "hero": {
      "title": "Criterios de recompra",
      "desc": "Comprueba los criterios antes del envío para evitar rechazos y agilizar el tratamiento de las piezas."
    },
    "intro": {
      "badge": "Comprobar",
      "title": "Piezas que podemos valorizar",
      "p1Strong": "El precio depende del modelo y del grado",
      "p1Rest": "cada pieza se prueba al recibirla antes de elaborar la oferta.",
      "p2Strong": "Las piezas fuera de los criterios no se compran",
      "p2Rest": "clasificarlas antes del envío ahorra tiempo a ambas partes.",
      "alert": "Cantidad mínima: 15 piezas. Cuanto mayor sea el lote, más interesante será el envío."
    },
    "examples": {
      "title": "Grados de las pantallas",
      "cracks": {
        "title": "Grado A",
        "bodyPrefix": "Pantalla con",
        "bodyStrong": "cristal roto",
        "bodySuffix": ", imagen y táctil funcionales."
      },
      "spots": {
        "title": "Grado B",
        "bodyPrefix": "Pantalla con",
        "onlyWord": "táctil averiado",
        "middle": "e",
        "perfectDisplay": "imagen aprovechable",
        "bodySuffix": "."
      },
      "touch": {
        "title": "Grado C",
        "bodyPrefix": "Pantalla con",
        "seriesStrong": "pequeñas sombras o marcas leves",
        "bodySuffix": " en la imagen."
      }
    },
    "recap": {
      "title": "Otros criterios importantes",
      "i1": "No aceptamos pantallas con píxeles muertos.",
      "i2": "Las placas base deben estar obligatoriamente desbloqueadas de iCloud.",
      "i3": "Aceptamos cámaras y conectores de carga incluso cuando están averiados.",
      "i4": "Para iPhone, aceptamos modelos a partir del iPhone X y XR.",
      "i5": "Para Samsung, Google, Huawei y otras marcas, prioriza modelos de menos de 5 años.",
      "i6": "Solo compramos pantallas originales. No aceptamos copias.",
      "ctaTarifs": "Ver tarifas",
      "ctaEnvoi": "¿Cómo embalar?"
    },
    "dialog": {
      "title": "Criterios de recompra",
      "screens": "Pantallas",
      "gradeA": "cristal roto, imagen y táctil funcionales.",
      "gradeB": "táctil averiado, imagen aprovechable.",
      "gradeC": "pequeñas sombras o marcas leves en la imagen.",
      "originals": "Solo pantallas originales: no se aceptan copias.",
      "motherboardsLabel": "Placas base",
      "motherboards": "deben estar obligatoriamente desbloqueadas de iCloud.",
      "partsLabel": "Conectores de carga y cámaras",
      "parts": "también los aceptamos cuando están averiados.",
      "disclaimer": "Comprueba estos criterios antes del envío. Las piezas que no los cumplen generan tiempo de tratamiento innecesario para ambas partes.",
      "back": "Volver a mi selección",
      "close": "Cerrar",
      "understand": "Entendido"
    }
  },
  "it": {
    "hero": {
      "title": "Criteri di riacquisto",
      "desc": "Verifica i criteri prima della spedizione per evitare rifiuti e velocizzare la lavorazione dei componenti."
    },
    "intro": {
      "badge": "Da verificare",
      "title": "Componenti che possiamo valorizzare",
      "p1Strong": "Il prezzo dipende dal modello e dal grado",
      "p1Rest": "ogni componente viene testato alla ricezione prima della formulazione dell’offerta.",
      "p2Strong": "I componenti fuori criterio non vengono acquistati",
      "p2Rest": "selezionarli prima della spedizione fa risparmiare tempo a entrambe le parti.",
      "alert": "Quantità minima: 15 componenti. Più grande è il lotto, più conveniente è la spedizione."
    },
    "examples": {
      "title": "Gradi degli schermi",
      "cracks": {
        "title": "Grado A",
        "bodyPrefix": "Schermo con",
        "bodyStrong": "vetro rotto",
        "bodySuffix": ", display e touch funzionanti."
      },
      "spots": {
        "title": "Grado B",
        "bodyPrefix": "Schermo con",
        "onlyWord": "touch non funzionante",
        "middle": "e",
        "perfectDisplay": "display utilizzabile",
        "bodySuffix": "."
      },
      "touch": {
        "title": "Grado C",
        "bodyPrefix": "Schermo con",
        "seriesStrong": "piccole ombre o segni leggeri",
        "bodySuffix": " sul display."
      }
    },
    "recap": {
      "title": "Altri criteri importanti",
      "i1": "Non accettiamo schermi con pixel guasti.",
      "i2": "Le schede madri devono essere obbligatoriamente sbloccate da iCloud.",
      "i3": "Accettiamo fotocamere e connettori di ricarica anche quando sono guasti.",
      "i4": "Per gli iPhone, accettiamo i modelli a partire da iPhone X e XR.",
      "i5": "Per Samsung, Google, Huawei e altri marchi, privilegia i modelli con meno di 5 anni.",
      "i6": "Acquistiamo esclusivamente schermi originali. Le copie non sono accettate.",
      "ctaTarifs": "Vedi le tariffe",
      "ctaEnvoi": "Come imballare?"
    },
    "dialog": {
      "title": "Criteri di riacquisto",
      "screens": "Schermi",
      "gradeA": "vetro rotto, display e touch funzionanti.",
      "gradeB": "touch non funzionante, display utilizzabile.",
      "gradeC": "piccole ombre o segni leggeri sul display.",
      "originals": "Solo schermi originali: le copie non sono accettate.",
      "motherboardsLabel": "Schede madri",
      "motherboards": "devono essere obbligatoriamente sbloccate da iCloud.",
      "partsLabel": "Connettori di ricarica e fotocamere",
      "parts": "li accettiamo anche quando sono guasti.",
      "disclaimer": "Verifica questi criteri prima della spedizione. I componenti non conformi comportano tempi di lavorazione inutili per entrambe le parti.",
      "back": "Torna alla selezione",
      "close": "Chiudi",
      "understand": "Ho capito"
    }
  },
  "de": {
    "hero": {
      "title": "Ankaufskriterien",
      "desc": "Prüfen Sie die Kriterien vor dem Versand, um Ablehnungen zu vermeiden und die Bearbeitung zu beschleunigen."
    },
    "intro": {
      "badge": "Bitte prüfen",
      "title": "Teile, die wir ankaufen können",
      "p1Strong": "Der Preis richtet sich nach Modell und Zustandsklasse",
      "p1Rest": "jedes Teil wird nach Eingang geprüft, bevor wir ein Angebot erstellen.",
      "p2Strong": "Teile außerhalb der Kriterien werden nicht angekauft",
      "p2Rest": "eine Vorsortierung spart Ihrem und unserem Team Zeit.",
      "alert": "Mindestmenge: 15 Teile. Je größer die Menge, desto wirtschaftlicher ist der Versand."
    },
    "examples": {
      "title": "Display-Zustandsklassen",
      "cracks": {
        "title": "Klasse A",
        "bodyPrefix": "Display mit",
        "bodyStrong": "gebrochenem Glas",
        "bodySuffix": ", funktionierender Anzeige und Touchfunktion."
      },
      "spots": {
        "title": "Klasse B",
        "bodyPrefix": "Display mit",
        "onlyWord": "defekter Touchfunktion",
        "middle": "und",
        "perfectDisplay": "nutzbarer Anzeige",
        "bodySuffix": "."
      },
      "touch": {
        "title": "Klasse C",
        "bodyPrefix": "Display mit",
        "seriesStrong": "kleinen Schatten oder leichten Spuren",
        "bodySuffix": " in der Anzeige."
      }
    },
    "recap": {
      "title": "Weitere wichtige Kriterien",
      "i1": "Displays mit defekten Pixeln werden nicht angenommen.",
      "i2": "Mainboards müssen vollständig von der iCloud-Sperre befreit sein.",
      "i3": "Kameras und Ladeanschlüsse nehmen wir auch im defekten Zustand an.",
      "i4": "Bei iPhones nehmen wir Modelle ab dem iPhone X und XR an.",
      "i5": "Bei Samsung, Google, Huawei und anderen Marken sollten die Modelle möglichst jünger als 5 Jahre sein.",
      "i6": "Wir kaufen ausschließlich Originaldisplays an. Kopien werden nicht angenommen.",
      "ctaTarifs": "Preise ansehen",
      "ctaEnvoi": "Wie verpacken?"
    },
    "dialog": {
      "title": "Ankaufskriterien",
      "screens": "Displays",
      "gradeA": "gebrochenes Glas, funktionierende Anzeige und Touchfunktion.",
      "gradeB": "defekte Touchfunktion, nutzbare Anzeige.",
      "gradeC": "kleine Schatten oder leichte Spuren in der Anzeige.",
      "originals": "Nur Originaldisplays: Kopien werden nicht angenommen.",
      "motherboardsLabel": "Mainboards",
      "motherboards": "sie müssen vollständig von der iCloud-Sperre befreit sein.",
      "partsLabel": "Ladeanschlüsse und Kameras",
      "parts": "wir nehmen sie auch im defekten Zustand an.",
      "disclaimer": "Bitte prüfen Sie diese Kriterien vor dem Versand. Nicht konforme Teile verursachen auf beiden Seiten unnötigen Bearbeitungsaufwand.",
      "back": "Zurück zur Auswahl",
      "close": "Schließen",
      "understand": "Verstanden"
    }
  },
  "pt": {
    "hero": {
      "title": "Critérios de recompra",
      "desc": "Verifique os critérios antes do envio para evitar peças rejeitadas e acelerar o processamento."
    },
    "intro": {
      "badge": "Verificar primeiro",
      "title": "Peças que podemos recuperar",
      "p1Strong": "Os preços dependem do modelo e do grau",
      "p1Rest": "cada peça é testada após o receção antes de emitir uma oferta.",
      "p2Strong": "Partes fora dos critérios não são adquiridas",
      "p2Rest": "A classificação antes do carregamento poupa tempo tanto para a sua equipa como para a nossa.",
      "alert": "Quantidade mínima: 15 partes. Quanto maior o lote, mais vale a pena o carregamento."
    },
    "examples": {
      "title": "Classes de ecrã",
      "cracks": {
        "title": "Grau A",
        "bodyPrefix": "Tela com",
        "bodyStrong": "vidro partido",
        "bodySuffix": ", exibição de trabalho e toque."
      },
      "spots": {
        "title": "Grau B",
        "bodyPrefix": "Tela com",
        "onlyWord": "função tátil avariada",
        "middle": "e a",
        "perfectDisplay": "ecrã utilizável",
        "bodySuffix": "."
      },
      "touch": {
        "title": "Grau C",
        "bodyPrefix": "Ecrã mostrando",
        "seriesStrong": "pequenas sombras ou marcas de luz",
        "bodySuffix": "no visor."
      }
    },
    "recap": {
      "title": "Outros critérios importantes",
      "i1": "Ecrãs com pixels mortos não são aceitas.",
      "i2": "As placas-mãe devem estar completamente livres de qualquer bloqueio iCloud.",
      "i3": "Câmeras e conectores de carregamento são aceitos mesmo quando defeituosos.",
      "i4": "Para iPhones, aceitamos modelos do iPhone X e XR em diante.",
      "i5": "Para a Samsung, Google, Huawei e outras marcas, priorize modelos com menos de 5 anos.",
      "i6": "Nós só compramos ecrãs originais. Cópias não são aceitas.",
      "ctaTarifs": "Ver preços",
      "ctaEnvoi": "Como embalar?"
    },
    "dialog": {
      "title": "Critérios de recompra",
      "screens": "Ecrãs",
      "gradeA": "vidro partido, imagem e função tátil a funcionar.",
      "gradeB": "função tátil avariada, display utilizável.",
      "gradeC": "pequenas sombras ou marcas de luz no visor.",
      "originals": "Apenas ecrãs originais: as cópias não são aceitas.",
      "motherboardsLabel": "Placas-mãe",
      "motherboards": "Devem estar completamente livres de qualquer bloqueio iCloud.",
      "partsLabel": "Conectores de carga e câmaras",
      "parts": "Também os aceitamos quando são defeituosos.",
      "disclaimer": "Por favor, verifique estes critérios antes do envio. Partes que não as atendem criam tempo de processamento desnecessário tanto para sua equipe quanto para a nossa.",
      "back": "Voltar para a minha seleção",
      "close": "Fechar",
      "understand": "Compreendo."
    }
  },
  "cs": {
    "hero": {
      "title": "Výkupní kritéria",
      "desc": "Zkontrolujte kritéria před odesláním, aby se zabránilo odmítnuté díly a urychlit zpracování."
    },
    "intro": {
      "badge": "Nejdřív se podívej.",
      "title": "Části můžeme obnovit",
      "p1Strong": "Ceny závisí na modelu a třídě",
      "p1Rest": "Každá část je testována po obdržení před vydáním nabídky.",
      "p2Strong": "Části mimo kritéria nejsou nakupovány",
      "p2Rest": "třídění před odesláním šetří čas jak pro váš tým, tak pro náš.",
      "alert": "Minimální množství: 15 dílů. Čím větší várka, tím cennější zásilka."
    },
    "examples": {
      "title": "Třídy obrazovky",
      "cracks": {
        "title": "Stupeň A",
        "bodyPrefix": "Obrazovka s",
        "bodyStrong": "rozbité sklo",
        "bodySuffix": ", pracovní zobrazení a dotyk."
      },
      "spots": {
        "title": "Stupeň B",
        "bodyPrefix": "Obrazovka s",
        "onlyWord": "nepracovní dotyk",
        "middle": "a",
        "perfectDisplay": "použitelný displej",
        "bodySuffix": "."
      },
      "touch": {
        "title": "Stupeň C",
        "bodyPrefix": "Zobrazení obrazovky",
        "seriesStrong": "malé stíny nebo světelné značky",
        "bodySuffix": "na displeji."
      }
    },
    "recap": {
      "title": "Další důležitá kritéria",
      "i1": "Obrazovky s mrtvými pixely nejsou akceptovány.",
      "i2": "Základní desky musí být zcela bez jakéhokoliv zámku iCloud.",
      "i3": "Kamery a nabíjecí konektory jsou přijímány, i když jsou vadné.",
      "i4": "Pro iPhony, přijímáme modely z iPhone X a XR dále.",
      "i5": "Pro Samsung, Google, Huawei a další značky, upřednostnit modely mladší než 5 let.",
      "i6": "Kupujeme jen originální obrazovky. Kopie nejsou přijímány.",
      "ctaTarifs": "Pohled ceny",
      "ctaEnvoi": "Jak balit?"
    },
    "dialog": {
      "title": "Kritéria zpětného odkupu",
      "screens": "Obrazovky",
      "gradeA": "rozbité sklo, pracovní zobrazení a dotyk.",
      "gradeB": "nefunkční dotyk, použitelný displej.",
      "gradeC": "malé stíny nebo světelné stopy na displeji.",
      "originals": "Pouze původní obrazovky: kopie nejsou přijímány.",
      "motherboardsLabel": "Základní desky",
      "motherboards": "Musí být zcela bez jakéhokoliv zámku iCloud.",
      "partsLabel": "Nabíjecí konektory a kamery",
      "parts": "Přijímáme je také, když jsou vadné.",
      "disclaimer": "Před odesláním zkontrolujte tato kritéria. Části, které se s nimi nesetkají, vytvářejí zbytečnou dobu zpracování jak pro váš tým, tak pro náš.",
      "back": "Zpět na můj výběr",
      "close": "Zavřít",
      "understand": "Rozumím."
    }
  },
  "nl": {
    "hero": {
      "title": "Inkoopcriteria",
      "desc": "Controleer de criteria voor verzending om afgewezen onderdelen te voorkomen en de verwerking te versnellen."
    },
    "intro": {
      "badge": "Controleer eerst",
      "title": "Onderdelen die we kunnen herstellen",
      "p1Strong": "Prijzen zijn afhankelijk van het model en de kwaliteit",
      "p1Rest": "elk onderdeel wordt getest na ontvangst voordat we een aanbieding.",
      "p2Strong": "Delen buiten de criteria worden niet gekocht",
      "p2Rest": "sorteren voor verzending bespaart tijd voor zowel uw team als het onze.",
      "alert": "Minimum aantal: 15 delen. Hoe groter de partij, hoe meer waard de zending."
    },
    "examples": {
      "title": "Schermkwaliteiten",
      "cracks": {
        "title": "Klasse A",
        "bodyPrefix": "Scherm met",
        "bodyStrong": "gebroken glas",
        "bodySuffix": ", werken display en touch."
      },
      "spots": {
        "title": "Graad B",
        "bodyPrefix": "Scherm met",
        "onlyWord": "niet-werkende aanraking",
        "middle": "en a",
        "perfectDisplay": "bruikbaar display",
        "bodySuffix": "."
      },
      "touch": {
        "title": "Graad C",
        "bodyPrefix": "Scherm tonen",
        "seriesStrong": "kleine schaduwen of lichtmarkeringen",
        "bodySuffix": "Op het display."
      }
    },
    "recap": {
      "title": "Andere belangrijke criteria",
      "i1": "Schermen met dode pixels worden niet geaccepteerd.",
      "i2": "Moederborden moeten volledig vrij zijn van elk iCloud slot.",
      "i3": "Camera's en oplaadconnectoren worden ook geaccepteerd als ze defect zijn.",
      "i4": "Voor iPhones accepteren we modellen vanaf de iPhone X en XR.",
      "i5": "Voor Samsung, Google, Huawei en andere merken, prioriteit modellen minder dan 5 jaar oud.",
      "i6": "Wij kopen alleen originele schermen. Kopieën worden niet geaccepteerd.",
      "ctaTarifs": "Prijzen bekijken",
      "ctaEnvoi": "Hoe verpakken?"
    },
    "dialog": {
      "title": "Inkoopcriteria",
      "screens": "Schermen",
      "gradeA": "gebroken glas, werkende display en aanraking.",
      "gradeB": "niet-werkende aanraking, bruikbaar display.",
      "gradeC": "kleine schaduwen of lichte markeringen op het display.",
      "originals": "Alleen originele schermen: kopieën worden niet geaccepteerd.",
      "motherboardsLabel": "Moederborden",
      "motherboards": "zij moeten volledig vrij zijn van elk iCloud slot.",
      "partsLabel": "Oplaadconnectoren en camera's",
      "parts": "We accepteren ze ook als ze defect zijn.",
      "disclaimer": "Controleer deze criteria voor verzending. Onderdelen die niet voldoen creëren onnodige verwerkingstijd voor zowel uw team als het onze.",
      "back": "Terug naar mijn selectie",
      "close": "Sluiten",
      "understand": "Ik begrijp het."
    }
  }
};

export default critereI18n;
